import React, { memo } from 'react'
import { Box, Button } from '@mui/material'
import Copy from '@v4/components/common/FAIcons/Light/Copy'
import TrashAlt from '@v4/components/common/FAIcons/Light/TrashAlt'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import ScoreTierDropdown from './components/ScoreTierDropdown'
import { useSectionAction } from './SectionAction.hooks'

const SectionAction = props => {
	const [
		{ classes, title, withCopy, withRemove, withToggle, VisibilityIcon, showContent, activeTierId },
		{ handleDelete, handleClone, handleVisibilityClick, handleStopPropagation, handleDynamicContentChange },
	] = useSectionAction(props)

	return (
		<div className={clsx(classes.root)}>
			{showContent && (
				<>
					<div className={classes.container}>
						<div className={classes.title}>{title}</div>
						{activeTierId && (
							<div className={classes.tierSelector}>
								<ScoreTierDropdown onChange={handleDynamicContentChange} value={activeTierId} />
							</div>
						)}
					</div>
					<Box className={classes.groupButton} direction="row" spacing={1} onClick={handleStopPropagation}>
						{withCopy && (
							<Button
								onClick={handleClone}
								size="small"
								className={clsx(classes.actionButton, classes.greenHover)}
							>
								<Copy />
							</Button>
						)}
						{withToggle && (
							<Button
								onClick={handleVisibilityClick}
								size="small"
								className={clsx(classes.actionButton, classes.greenHover)}
							>
								<VisibilityIcon />
							</Button>
						)}
						{withRemove && (
							<Button
								className={clsx(classes.actionButton, classes.redHover)}
								onClick={handleDelete}
								size="small"
							>
								<TrashAlt />
							</Button>
						)}
					</Box>
				</>
			)}
		</div>
	)
}
SectionAction.propTypes = {
	title: PropTypes.string.isRequired,
	withCopy: PropTypes.bool.isRequired,
	withRemove: PropTypes.bool.isRequired,
	withToggle: PropTypes.bool.isRequired,
	sectionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	visibility: PropTypes.number.isRequired,
	showContent: PropTypes.bool,
	sectionKey: PropTypes.string.isRequired,
	offset: PropTypes.shape({
		top: PropTypes.number,
		bottom: PropTypes.number,
	}),
	dynamicGroup: PropTypes.string,
}

export default memo(SectionAction)
